/**
 * Runtime configuration types for the application
 */

export interface ApiConfig {
  baseUrl: string;
  loginPath: string;
  useProxy: boolean;
  proxyPath: string;
}

export interface FeaturesConfig {
  enableOfflineMode: boolean;
  enableDebugLogging: boolean;
}

export interface AppConfig {
  environment: 'development' | 'testing' | 'staging' | 'production';
  smartApi: ApiConfig;
  swsApi: ApiConfig;
  features: FeaturesConfig;
}

export const DEFAULT_CONFIG: AppConfig = {
  environment: 'production',
  smartApi: {
    baseUrl: 'https://smart.reboundynamics.com/public',
    loginPath: '/base/v1/logins',
    useProxy: false,
    proxyPath: ''
  },
  swsApi: {
    baseUrl: 'https://api.reboundynamics.com/api/v1',
    loginPath: '/login',
    useProxy: false,
    proxyPath: ''
  },
  features: {
    enableOfflineMode: true,
    enableDebugLogging: false
  }
};